import { useEffect, useState, useRef } from "react"
import Button from "../../../../button/button"
import Modal from "../../../../modal/modal"
import Select from "../../../../select/select"
import './TFollowUpAdd.scss'
import { GetAllTeachersBySubsidiaryOrInchargeReceptionist } from "../../../../../utils/Apis/principalApis"
import InputAutoComplete from "../../../../autocomplete/autocomplete"
import { useNavigate } from "react-router-dom"
import { GetRecepcionistListInChargeByTeacherEmployeeId, InsertRelTeacherWithReceptionist, PatchReplaceRelTeacherWithReceptionist } from "../../../../../utils/Apis/receptionApis"
import OptionConfirmModal from "../../../../OptionConfirmModal/OptionConfirmModal"
import Autocomplete from "../../../../../DesignSystem/Molecules/Autocomplete/Autocomplete"
const TFollowUpAdd = ({ showAlert, refreshData, isOpen, onClose, listSubsidiary, employee_id, cacheTeacherGroupsList, cacheTeacherListFollowUpMain }) => {
    const [subsidiarySelected, setSubsidiarySelected] = useState('')
    const [teacherListState, setTeacherListState] = useState([])
    const [teacherSelected, setTeacherSelected] = useState({})
    const [disabledButton, setDisabledButton] = useState(false)
    const [isSelectActionOpen, setIsSelectActionOpen] = useState(false)
    const [oldReceptionists, setOldReceptionists] = useState([]);
    const cacheTeacherList = useRef({}); // 🔄 Caché por plantel
    const navigate = useNavigate()
    useEffect(() => {
        const controller = new AbortController();
        const fetchTeacher = async () => {

            try {
                // 🔍 Revisamos si ya tenemos el resultado en caché
                if (subsidiarySelected in cacheTeacherList.current) {
                    const cachedData = cacheTeacherList.current[subsidiarySelected];
                    setTeacherListState(cachedData);
                    return;
                }
                const getAllTeacherBySubsidiary = await GetAllTeachersBySubsidiaryOrInchargeReceptionist(null, subsidiarySelected, false)
                if (controller.signal.aborted) return;

                if (getAllTeacherBySubsidiary.auth === false) {
                    navigate("/login");
                    return;
                }
                const formattedList = getAllTeacherBySubsidiary.result.map((v) => ({
                    employee_id: v.employee_id,
                    name: v.name,
                    contact: {
                        email: v.email,
                        phone: v.phone_number
                    }
                }));
                // 🧠 Guardar en caché
                cacheTeacherList.current[subsidiarySelected] = formattedList;
                setTeacherListState(formattedList)
            } catch (err) {
                if (!controller.signal.aborted) {
                }
            } finally {
                if (!controller.signal.aborted) {
                }
            }
        }


        fetchTeacher()
    }, [subsidiarySelected])
    const handleChangeSubsidiary = (value) => {
        setSubsidiarySelected(value)
        setTeacherSelected({})
    }

    // Función para construir el nombre completo
    const getFullName = (teacher) => {
        return `${teacher.name}`;
    };

    const handleTeacherChange = (value) => {
      if (value === null) {
        setTeacherSelected({})
        return;
      }
      setTeacherSelected(value)
   

  }

    const handleConfirmAddTeacherInReceptionist = async () => {
        setDisabledButton(true)
        if (!teacherSelected?.employee_id) {
            showAlert('warning', 'Seleccione maestro a asignar')
            setDisabledButton(false)
            return
        }
        const teacher_employee_id = teacherSelected.employee_id
        const getReceptionistList = await GetRecepcionistListInChargeByTeacherEmployeeId(teacher_employee_id)
        if (!getReceptionistList.hasReceptionist) {
            const responserInsertRel = await InsertRelTeacherWithReceptionist(employee_id, teacher_employee_id)

            if (responserInsertRel.status === 200) {
                showAlert('success', responserInsertRel.message)
                await refreshData();
                onClose();
            } else {
                showAlert('danger', responserInsertRel.message)
                setDisabledButton(false)
                return
            }

        } else {
            const listResponse = getReceptionistList.response
            const findSameReceptionist = listResponse.some((v) => v.receptionist_charge_id_employee === employee_id)
            if (findSameReceptionist) {
                showAlert('danger', 'El Recepcionista ya esta asignado con este profesor')
                setDisabledButton(false)
                return
            }

            setOldReceptionists(listResponse);
            setIsSelectActionOpen(true)
        }

    }

    const handleAddAnotherReceptionist = async () => {

        const response = await InsertRelTeacherWithReceptionist(
            employee_id,
            teacherSelected.employee_id
        );

        if (response.status === 200) {
            showAlert('success', response.message);

            await refreshData();

            setIsSelectActionOpen(false);

            onClose();
        } else {
            showAlert('danger', response.message);
        }
    };

    const handleReplaceReceptionist = async () => {
        const response = await PatchReplaceRelTeacherWithReceptionist(
            employee_id,
            teacherSelected.employee_id
        );

        if (response.status === 200) {
            // Limpiar cache de todos los recepcionistas anteriores
            oldReceptionists.forEach((recep) => {
                delete cacheTeacherGroupsList.current[
                    recep.receptionist_charge_id_employee
                ];
            });

            // También limpiar el del nuevo recepcionista
            delete cacheTeacherGroupsList.current[employee_id];

            // La vista "mis maestros"
            delete cacheTeacherListFollowUpMain.current["mine"];

            await refreshData();

            showAlert("success", response.message);

            setIsSelectActionOpen(false);
            onClose();
        }
    };

    const handleCancelOptionSelection = () => {
        setIsSelectActionOpen(false)
        setDisabledButton(false)
    }
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
                <div className="t-follow-up-add-container">
                    <h1 className="title-1">Asignar Maestro-Recepcionista</h1>
                    <div className="selects-body">
                        <Select
                            value={subsidiarySelected}
                            options={listSubsidiary}
                            onChange={(e) => handleChangeSubsidiary(e.target.value)}
                            placeholder={'Selecciona Sucursal del maestro'}
                        />
                        <Autocomplete
                            options={teacherListState}// Pasa los objetos completos como opciones 
                            getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                            value={
                                Object.keys(teacherSelected).length !== 0 ? teacherListState.find(t => t.employee_id === teacherSelected.employee_id) : null
                            } // Aquí pasas el objeto completo
                            onChange={(value) => handleTeacherChange(value)}
                            placeholder={"Busca al maestro"}
                        />


                    </div>
                    <div className="confirm-buttons-section">
                        <Button text='Cancelar' backgroundColor="red" onClick={onClose} disabled={disabledButton} />
                        <Button text='Confirmar' onClick={handleConfirmAddTeacherInReceptionist} disabled={disabledButton} />

                    </div>
                </div>

                <OptionConfirmModal
                    isOpen={isSelectActionOpen}
                    title="El maestro ya tiene asesores"
                    text="Seleccione qué acción desea realizar"
                    handleCancel={handleCancelOptionSelection}
                    options={[
                        {
                            text: "Agregar asesor adicional",
                            action: handleAddAnotherReceptionist
                        },
                        {
                            text: "Sustituir asesores actuales",
                            action: handleReplaceReceptionist
                        }
                    ]}
                />
            </Modal>
        </>
    )
}
export default TFollowUpAdd